import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { LogModule, LogService } from '../services/log.service';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private logService: LogService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const startTime = Date.now();
    const { method, urlWithParams } = request;

    return next.handle(request).pipe(
      tap({
        next: (event) => {
          const duration = Date.now() - startTime;
          // graphql logging
          if (
            request.method === 'POST' &&
            request.body &&
            typeof request.body.query === 'string'
          ) {
            const { operationName, query, variables } = request.body;
            const safeVars = this.maskSensitiveFields(variables);
            const msg =
              `GraphQL Request: ${operationName || 'Unnamed'}\n` +
              `duration: ${duration}ms\n` +
              `Method: ${method}\n` +
              `Variables: ${JSON.stringify(safeVars)}\n`;
            this.logService.logInfo(msg, LogModule.GRAPHQL);
          }

          if (event instanceof HttpResponse) {
            this.logService.logInfo(
              `✅ ${method} ${urlWithParams} - ${event.status} (${duration}ms)\n`
            );
          }
        },
        error: (error: HttpErrorResponse) => {
          const duration = Date.now() - startTime;
          this.logService.logError(
            `❌ ${method} ${urlWithParams} - ${error.status} (${duration}ms): ${error.message}\n`
          );
        },
      })
    );
  }

  private maskSensitiveFields(obj: any): any {
    if (!obj || typeof obj !== 'object') return obj;

    const SENSITIVE_KEYS = ['password', 'pwd', 'secret', 'pass', 'token'];
    const masked: any = Array.isArray(obj) ? [] : {};

    for (const key of Object.keys(obj)) {
      if (SENSITIVE_KEYS.includes(key.toLowerCase())) {
        masked[key] = '********'; // 🔒 Mask value
      } else if (typeof obj[key] === 'object') {
        masked[key] = this.maskSensitiveFields(obj[key]); // 🔁 Recurse
      } else {
        masked[key] = obj[key];
      }
    }

    return masked;
  }
}
